module.exports = __webpack_public_path__ + "img/knro_b.4caefce1.png";